<script setup>
import { ref, onMounted, nextTick, computed, watch } from "vue";
import { useSettingsStore } from "@/stores/storeSettings";
import { useFieldsStore } from "@/stores/storeFieldData";
import { useRequestsStore } from "@/stores/storeRequests";
import { useQuestionnairesStore } from "@/stores/storeQuestionnaires";
import { useRoute } from "vue-router";
import { useModals } from "@/utils/useModals";
import { policyUrl, rulesUrl, agreementUrl } from "@/utils/provider";
import BaseCheckbox from "@/components/ui/BaseCheckbox.vue";
import BaseFile from "@/components/ui/BaseFile.vue";
import BaseInput from "@/components/ui/BaseInput.vue";
import BaseDateInput from "@/components/ui/BaseDateInput.vue";
import BasePhoneInput from "@/components/ui/BasePhoneInput.vue";
import BaseNumberInput from "@/components/ui/BaseNumberInput.vue";

const storeSettings = useSettingsStore();
const storeField = useFieldsStore();
const storeRequests = useRequestsStore();
const storeQuestionnaires = useQuestionnairesStore();
const route = useRoute();
const { openModal } = useModals();


const props = defineProps({
	currentForm: {
		type: Object,
		default: () => {}
	}
})

const persnalDataBtns = ['firstName', 'lastName', 'patronymic', 'phone', 'email', 'agreement']
const persnalPassportBtns = ['birthDate', 'series', 'number', 'issuedBy', 'issueDate', 'departmentCode', 'inn']
const persnalAddressBtns = ['zipCode', 'city', 'street', 'house']

const disabledBtn = computed(() => {
	if(storeQuestionnaires.questionnaireType === 'cash-prize') return storeField.isBtnDisabled([...persnalDataBtns, ...persnalPassportBtns, 'bik', 'accountNumber',])
	if(storeQuestionnaires.questionnaireType === 'tax-free-cash-prize') return storeField.isBtnDisabled([...persnalDataBtns, 'inn', 'bik', 'accountNumber'])
	if(storeQuestionnaires.questionnaireType === 'physical-prize') return storeField.isBtnDisabled([...persnalDataBtns, ...persnalPassportBtns, ...persnalAddressBtns])
	if(storeQuestionnaires.questionnaireType === 'tax-free-physical-prize') return storeField.isBtnDisabled([...persnalDataBtns, ...persnalAddressBtns])
})

const emit = defineEmits(['questionnaireFormShow'])

onMounted(async () => {
	console.log('storeQuestionnaires.questionnaireType:',storeQuestionnaires.questionnaireType);
});
</script>
<template>	
	<div class="questionnaire">
		<div class="container --pc" >
			<div class="questionnaire__header">
				<h1 class="questionnaire__title title">Заполнение анкеты</h1>
				<h2 class="questionnaire__subtitle">Денежный приз</h2>
			</div>
			<div class="questionnaire__form form">
				<div class="questionnaire__inputs">
					<div class="questionnaire__box-input">
						<BaseInput mask-type="cyrillic" type="text" placeholder="Фамилия" :required="true" state-key="lastName">Фамилия</BaseInput>
					</div>
					<div class="questionnaire__box-input">
						<BaseInput mask-type="cyrillic" type="text" placeholder="Имя" :required="true" state-key="firstName"> Имя </BaseInput>
					</div>
					<div class="questionnaire__box-input">
						<BaseInput mask-type="cyrillic" type="text" placeholder="Отчество" :required="true" state-key="patronymic">Отчество</BaseInput>
					</div>
					<div :class="['questionnaire__box-input']">
						<BasePhoneInput :required="true" placeholder="+7 (900) 000-00-00" state-key="phone" >Номер телефона</BasePhoneInput>
					</div>
					<div :class="['questionnaire__box-input']">
						<BaseInput mask-type="email" type="text" placeholder="example@mail.ru" :required="true" state-key="email">Email</BaseInput>
					</div>
					<div class="questionnaire__box-input" v-if="props.currentForm.numbers && !props.currentForm.passport">
						<BaseNumberInput 
							:required="true" 
							placeholder="000000000000" 
							mask="999999999999"  
							maskPlaceholder=""
							state-key="inn" 
						>
							ИНН — 12 цифр
						</BaseNumberInput>
					</div>
					<!-- <div :class="['questionnaire__box-input', { '--full' : !props.currentForm.passport } ]">
						<BasePhoneInput :required="true" placeholder="+7 (900) 000-00-00" state-key="phone" >Номер телефона</BasePhoneInput>
					</div>
					<div :class="['questionnaire__box-input', { '--full' : !props.currentForm.passport } ]">
						<BaseInput mask-type="email" type="text" placeholder="example@mail.ru" :required="true" state-key="email">Email</BaseInput>
					</div> -->

					<!-- Паспорт -->
					<div class="questionnaire__box-input" v-if="props.currentForm.passport">
						<BaseDateInput 
							type="date" 
							placeholder=""
							:required="true" 
							state-key="birthDate" 
							min-date="1900-01-01"                      
						>
							Дата рождения
						</BaseDateInput>
					</div>					
					<div class="questionnaire__box-input " v-if="props.currentForm.passport">
						<BaseNumberInput 
							:required="true" 
							placeholder="0000" 
							mask="9999"  
							maskPlaceholder=""
							state-key="series" 
						>
							Серия паспорта — 4 цифры
						</BaseNumberInput>
					</div>
					<div class="questionnaire__box-input" v-if="props.currentForm.passport">
						<BaseNumberInput 
							:required="true" 
							placeholder="000000" 
							mask="999999"  
							maskPlaceholder=""
							state-key="number" 
						>
							Номер паспорта — 6 цифр
						</BaseNumberInput>
					</div>
					<div class="questionnaire__box-input" v-if="props.currentForm.passport">
						<BaseInput mask-type="cyrillic" type="text" placeholder="" :required="true" state-key="issuedBy">Кем выдан</BaseInput>
					</div>
					<div class="questionnaire__box-input" v-if="props.currentForm.passport">
						<BaseDateInput 
							:required="true" 
							type="date" 
							placeholder=""
							state-key="issueDate" 
							min-date="1900-01-01"                      
						>
							Дата выдачи
						</BaseDateInput>
					</div>
					<div class="questionnaire__box-input" v-if="props.currentForm.passport">
						<BaseNumberInput 
							:required="true" 
							placeholder="000-000" 
							mask="999 999"  
							maskPlaceholder=""
							state-key="departmentCode" 
						>
							Код подразделения
						</BaseNumberInput>
					</div>
					<div class="questionnaire__box-input" v-if="props.currentForm.passport">
						<BaseNumberInput 
							:required="true" 
							placeholder="000000000000" 
							mask="999999999999"  
							maskPlaceholder=""
							state-key="inn" 
						>
							ИНН — 12 цифр
						</BaseNumberInput>
					</div>	

					<!-- Адрес доставки приза -->
					<h3 class="questionnaire__address-title" v-if="props.currentForm.address">Адрес доставки приза</h3>
					<div class="questionnaire__box-input" v-if="props.currentForm.address">
						<BaseNumberInput 
							:required="true" 
							placeholder="000000" 
							mask="999999"  
							maskPlaceholder=""
							state-key="zipCode" 
						>
							Индекс — 6 цифр
						</BaseNumberInput>
					</div>	
					<div class="questionnaire__box-input" v-if="props.currentForm.address">
						<BaseInput type="text" placeholder="" maxLength="50" minLength="2" :required="true" state-key="city">Город</BaseInput>
					</div>
					<div class="questionnaire__box-input" v-if="props.currentForm.address">
						<BaseInput type="text" placeholder="" maxLength="100" minLength="2" :required="true" state-key="street">Улица</BaseInput>
					</div>
					<div class="questionnaire__box-input --full" v-if="props.currentForm.address">
						<BaseInput type="text" placeholder="" maxLength="10" minLength="1" :required="true" state-key="house">Номер дома</BaseInput>
					</div>
					<div class="questionnaire__box-input --full" v-if="props.currentForm.address">
						<BaseInput type="text" placeholder="" :required="false" state-key="apartment">Номер квартиры</BaseInput>
					</div>


					<div class="questionnaire__box-input --full" v-if="props.currentForm.numbers">
						<BaseNumberInput 
							:required="true" 
							placeholder="000000000" 
							mask="999999999"  
							maskPlaceholder=""
							state-key="bik" 
						>
							БИК банка — 9 цифр
						</BaseNumberInput>
					</div>

					<div class="questionnaire__box-input --full" v-if="props.currentForm.numbers">
						<BaseNumberInput 
							:required="true" 
							placeholder="4081 78" 
							mask="9999 9999 9999 9999 9999"
							maskPlaceholder="" 
							state-key="accountNumber" 
						>
							Номер счета — 20 цифр
						</BaseNumberInput>
					</div>
				</div>
				<div class="questionnaire__footer">
					<div class="form__wrap" v-if="props.currentForm.passport">
						<BaseFile>Прикрепить фото разворота паспорта с фотографией</BaseFile>
					</div>
					<BaseCheckbox 
						:required="true" 
						state-key="agreement"
						class="questionnaire__checkbox"
					>
						Даю согласие на <a href="./policy.pdf" target="_blank" rel="noopener noreferrer">обработку персональных данных</a>
					</BaseCheckbox>
					<p class="form__text-error" v-if="storeQuestionnaires.responseError">{{ storeQuestionnaires.responseError }}</p>
					<div class="questionnaire__buttons">
						<button :disabled="disabledBtn" :class="['send-button form__btn btn', { 'not-hover': storeQuestionnaires.loaderBtn }]" @click="storeQuestionnaires.sendQuestionnaire()">
							<span v-if="!storeQuestionnaires.loaderBtn">Отправить</span>
							<img v-else class="form__loader" width="36" height="36" src="@/assets/img/icons/loader.svg" alt="изображение"/>
						</button>
						<!-- <button class="form__btn btn --grey" @click="emit('questionnaireFormShow'), storeQuestionnaires.updateQuestionnaire(false)">Закрыть</button> -->
						<button class="form__btn btn --transparent" @click="openModal('feedback')">Написать в техподдержку</button>
					</div>
				</div>
			</div>
		</div>

	</div>	
</template>
<style lang="scss" scoped>
@use '@/assets/scss/base/vars';
.questionnaire {

}
.questionnaire__header {
	text-align: center;
	margin-bottom: 3rem;
	@media (max-width: vars.$x480) {
		margin-bottom: 1rem;
	}
}
.questionnaire__title {
	margin-bottom: 0.8rem;
}
.questionnaire__subtitle {
	font-weight: 400;
	font-size: 1.7rem;
	line-height: 129%;
	letter-spacing: -0.02em;
}
.questionnaire__form {
}
.questionnaire__inputs {
	display: grid;
	grid-template-columns: repeat(6, 1fr);
	gap: 1.3rem 4rem;
	@media (max-width: vars.$m) {
		gap: 1.3rem;
	}
	@media (max-width: vars.$xx) {
		grid-template-columns: 1fr;
		gap: 0;
	}
}
.questionnaire__address-title {
	font-weight: 590;
	font-size: 2rem;
	line-height: 125%;
	letter-spacing: -0.02em;
	grid-column: span 6;
}
.questionnaire__box-input {
	width: 100%;
	grid-column: span 2;
	@media (max-width: vars.$xx) {
		grid-column: span 1;
	}
	&.--full {
		grid-column: span 3;
		@media (max-width: vars.$xx) {
			grid-column: span 1;
		}
	}
}
.questionnaire__checkbox {
	padding: 3.5rem 0;
	@media (max-width: vars.$xx) {
		padding: 2rem 0;
	}
}
.questionnaire__footer {
}
.questionnaire__buttons {
	display: grid;
	grid-template-columns: repeat(3, 29.3rem );
	gap: 1rem;
	@media (max-width: vars.$xx) {
		grid-template-columns: 1fr;
		gap: 0.6rem;
	}
}

</style>
